import React, { useEffect, useState } from 'react'
import { Collapse } from '@material-tailwind/react'
import { Link } from 'gatsby'
import { useLocation } from '@gatsbyjs/reach-router'
import Logo from '../logo'
import { ExpendedMenu } from './expendedMenu'
import { MobileMenuButton } from './mobileMenuButton'
import { LinkButton } from './linkButton'

const AppsButtons = ({
  isCommercialLanding = false,
}: {
  isCommercialLanding: boolean
}) => {
  if (isCommercialLanding) {
    return (
      <LinkButton
        title="Accéder à l'espace cabinet"
        href="https://lamadash.fr/signup_login"
        label="Me connecter"
        isInverted
        size="medium"
        isExternal
      />
    )
  }
  return (
    <>
      <LinkButton
        title="Accéder à l'espace candidat"
        href="https://lamadash.fr/signup_login_candidat"
        label="Espace Candidat"
        isInverted
        size="medium"
        isExternal
      />
      <LinkButton
        title="Connexion / Inscription à l’Espace Cabinet Lamacompta"
        href="/je-suis-un-cabinet"
        label="Espace Cabinet"
        size="medium"
      />
    </>
  )
}

export const MegaMenuWithHover = () => {
  const [openNav, setOpenNav] = useState(false)
  const location = useLocation()

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => window.innerWidth >= 960 && setOpenNav(false),
    )
  }, [])

  const isCommercialLanding = location?.pathname === '/je-suis-un-cabinet'

  return (
    <nav
      id="navbar"
      data-testid="MegaMenuWithHover"
      role="navigation"
      className="sticky top-0 z-10 block w-full px-2 border-b shadow bg-very-light-blue border-lama-blue/40 py-1.5 md:py-0 md:px-0"
    >
      <div className="xl:w-[1115px] lg:w-[950px] mx-auto 2xl:w-[1320px] flex items-center justify-between h-full py-1.5 px-1 md:py-0 md:px-0">
        <Link
          className="flex-1 flex flex-row items-center max-w-[180px]"
          to="/"
          rel="preload"
          aria-label="Accéder à la page d'accueil"
        >
          <span className="flex-1">
            <Logo />
          </span>
        </Link>

        <div className="hidden md:flex md:items-center md:space-x-2 lg:hidden">
          <AppsButtons isCommercialLanding={isCommercialLanding} />
        </div>
        <div>
          <div className="hidden lg:block">
            <ExpendedMenu isCommercialLanding={isCommercialLanding} />
          </div>
          <MobileMenuButton
            openNav={openNav}
            // eslint-disable-next-line react/jsx-no-bind
            setOpenNav={setOpenNav}
          />
        </div>
        <div className="hidden lg:flex lg:items-center lg:space-x-2">
          <AppsButtons isCommercialLanding={isCommercialLanding} />
        </div>
      </div>

      <div />

      <Collapse open={openNav}>
        <ExpendedMenu isCommercialLanding={isCommercialLanding} />
      </Collapse>
    </nav>
  )
}
